import { createContext, useContext, useEffect, useState } from "react";
import api from "./api";

const SiteStatusContext = createContext({ maintenance: true, loaded: false });

// Maintenance is read from the backend's single MAINTENANCE_MODE setting; fails closed.
export const SiteStatusProvider = ({ children }) => {
  const [status, setStatus] = useState({ maintenance: true, loaded: false });
  useEffect(() => {
    api
      .get("/site-status")
      .then((r) => setStatus({ maintenance: r.data.maintenance !== false, loaded: true }))
      .catch(() => setStatus({ maintenance: true, loaded: true }));
  }, []);
  return <SiteStatusContext.Provider value={status}>{children}</SiteStatusContext.Provider>;
};

export const useSiteStatus = () => useContext(SiteStatusContext);

// AnswerStrike palette, taken from https://answerstrike.com
export const AS = {
  bg: "#f3f0e8",
  surface: "#faf8f1",
  text: "#173a38",
  muted: "#607468",
  eyebrow: "#6e806c",
  border: "#cdd4c3",
  panel: "#173a38",
  panelBorder: "#2b504b",
  panelText: "#ecead8",
  panelMuted: "#c1cec1",
  button: "#e7d39f",
  accent: "#dbc993",
};
